import './index.css'
import { Component } from 'react'

class SwitchComponent extends Component {
  updateDisable = () => {
    this.props.updateDisable()
  }

  render() {
    return (
      <label className="text-input-label">
        <div>{this.props.label}</div>
        <div className="month-picker-bottom" style={{ padding: '0px', marginLeft: '5px' }}>
          <label className="month-picker-bottom-label" onClick={this.updateDisable}>
            <div className={`radio-content ${this.props.value ? 'disable' : 'active'}`}>
              <div className={`radio-button ${this.props.value ? 'disable' : 'active'}`}></div>
            </div>
          </label>
        </div>
      </label>
    )
  }
}

SwitchComponent.defaultProps = { label: '', value: false }
export default SwitchComponent
